<template>
  <div>
    <loading :active.sync="isLoading" color="#85344c"></loading>
    <div class="content-wrapper">
      <div class="container-fluid">
        <!-- Breadcrumbs-->
        <ol class="breadcrumb">
          <li class="breadcrumb-item active">Assinantes</li>
        </ol>

        <div class="row">
          <div class="col-md-12" v-if="mostraErro">
            <div class="alert alert-danger alert-dismissible" role="alert">
              <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
              <strong>Ops!</strong>
              <span>{{erroMensagem}}</span>
            </div>
          </div>
        </div>

        <v-card>
          <div class="row filtros">
            <div class="col-md-3">
              <div class="form-group">
                <label>Selecione a data de início</label>
                <date-picker
                  v-model="dataFiltro.inicio"
                  :lang="lang"
                  format="DD/MM/YYYY"
                  value-type="format"
                  placeholder="Selecione uma data de inicio"
                ></date-picker>
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group">
                <label>Selecione a data de fim</label>
                <date-picker
                  v-model="dataFiltro.fim"
                  :lang="lang"
                  format="DD/MM/YYYY"
                  value-type="format"
                  placeholder="Selecione uma data de fim"
                ></date-picker>
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group">
                <label>Selecione um status</label>
                <select class="form-control" @change="e => statusAssinante = e.target.value" v-model="statusAssinante">
                  <option value="active">Ativo</option>
                  <option value="overdue">Atrasado</option>
                  <option value="suspended">Suspenso</option>
                  <option value="canceled">Cancelado</option>
                  <option value="error">Erro</option>
                </select>
              </div>
            </div>
            <div class="col-md-3 btns_center">
                  <button
                  class="btn_1 medium pull-right"
                  @click="filtraAssinante"
                >Filtrar</button>
            </div>
            <div class="col-md-2 btns_center">
                  <button
                  class="btn_1 medium pull-right"
                  @click="exportToPDF"
                >Exportar para PDF</button>
            </div>
            <div class="col-md-2 btns_center">
                  <button
                  class="btn_1 medium pull-right"
                  @click="exportToExcel"
                >Exportar para Excel</button>
            </div>
          </div>
          <v-card-title>
            Seus assinantes
            <v-spacer></v-spacer>
            <v-text-field
              v-model="search"
              append-icon="search"
              label="Filtrar"
              single-line
              hide-details
            ></v-text-field>
          </v-card-title>
          <v-data-table :headers="headers" :items="assinaturas" :search="search" :pagination.sync="pagination">
            <template slot="items" slot-scope="props">
              <td>{{ padronizaData(props.item.created_at) }}</td>
              <td>{{ props.item.name }}</td>
              <td>{{ props.item.subscriber_name }}</td>
              <td>{{ props.item.plans_description }}</td>
              <td>{{ formattedNumber(props.item.custom_price) }}</td>
              <td>{{ props.item.protocolo }}</td>
              <td>{{ props.item.status }}</td>
              <td class="text-xs-right">
                <router-link
                  :to="'/adm/assinantes/'+props.item.protocolo"
                >
                <span class="btn_1 gray delete wishlist_close button-content">
                  <i class="fa fa-fw fa-edit"></i> Detalhes
                </span>
                </router-link>
              </td>
            </template>
            <v-alert
              slot="no-results"
              :value="true"
              color="error"
              icon="warning"
            >Sua consulta para "{{ search }}" não teve resultado.</v-alert>
          </v-data-table>
        </v-card>
      </div>
      <!-- /container-fluid-->
    </div>
  </div>
</template>

<script>
import { ajax, tratamento_requisicao, alerta, padronizaDataUS} from "@/utils/util";
import funcoesGerais from "@/assets/js/funcoes.js";
import axios from "axios";
import moment from "moment";
import jsPDF from "jspdf";
import autoTable from 'jspdf-autotable';
var XLSX = require("xlsx");
export default {
  mixins: [funcoesGerais],
  data() {
    const dataAtual = new Date();
    const dataAtualArray = dataAtual.toLocaleDateString().split("T")[0].split("/");
    return {
      lang: {
        days: ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sab"],
        months: [
          "Jan",
          "Fev",
          "Mar",
          "Abr",
          "Mai",
          "Jun",
          "Jul",
          "Ago",
          "Set",
          "Out",
          "Nov",
          "Dec"
        ],
        pickers: [
          "prox 7 dias",
          "prox 30 dias",
          "7 dias anteriores",
          "30 dias anteriores"
        ],
        placeholder: {
          date: "Selecione a data",
          dateRange: "Selecione o intervalo"
        },
      },
      search: "",
      erroMensagem: "",
      mostraErro: false,
      assinaturas: [],
      isLoading: false,
      headers: [
        { text: "Data Assinatura", value: "data_pagamento" },
        { text: "Uniodonto", value: "name" },
        { text: "Assinante", value: "subscriber_name" },
        { text: "Plano", value: "plans_description" },
        { text: "Valor", value: "custom_price" },
        { text: "Protocolo", value: "protocolo"},
        { text: "Status", value: "status" },
        { text: "Opções", value: "" },
      ],
      statusAssinante: "active",
      dataFiltro: {
        inicio: `01/${dataAtualArray[1]}/${dataAtualArray[2]}`,
        fim: `${dataAtualArray[0]}/${dataAtualArray[1]}/${dataAtualArray[2]}`,
      },
      pagination: { sortBy: "created_at", descending: true }
    };
  },
  methods: {
    formattedNumber(number){
      return (number / 100).toLocaleString('pt-BR', { minimumFractionDigits: 2 });
    },
    getTableData() {
      return this.assinaturas.map(item => [
        item.data_pagamento,
        item.name,
        item.subscriber_name,
        item.plans_description,
        item.custom_price,
        item.protocolo,
        item.status
      ]);
    },
    exportToPDF() {
      const doc = new jsPDF();
      const tableData = this.getTableData();
      doc.setFontSize(8); 
      doc.text("Assinantes", 10, 10);
      autoTable(doc,{
        startY: 20,
        head: [['Data Assinatura', 'Uniodonto','Assinante', 'Plano', 'Valor', 'Protocolo', 'Status']],
        body: tableData,
      });
      doc.save('assinantes.pdf');
    },
    exportToExcel() {
      const tableData = this.getTableData();
      const ws = XLSX.utils.aoa_to_sheet([this.headers.map(h => h.text), ...tableData]);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'Assinantes');
      XLSX.writeFile(wb, 'assinantes.xlsx');
    },
    filtraAssinante(e){
      var self = this;
      self.isLoading = true;
      let inicio = "";
      let fim = "";
      self.dataFiltro.inicio ? inicio = padronizaDataUS(self.dataFiltro.inicio) : inicio = 0;
      self.dataFiltro.fim ? fim = padronizaDataUS(self.dataFiltro.fim) : fim = 0;
      ajax("get", "/assinaturas/"+self.statusAssinante+"/"+inicio+"/"+fim)
        .then((response) => {
          console.log(response)
          self.isLoading = false;
          self.assinaturas = response;
          self.assinaturas.map((assinatura)=> {
            assinatura.status = self.padronizaStatusAssinante(assinatura.status);
          })
        })
        .catch((error) => {
          self.isLoading = false;
          tratamento_requisicao(error, this);
        });
    },
  },
  created() {
    var self = this;
    var user = JSON.parse(localStorage.getItem("token_adm_comprodonto"));

    if (user) {
      self.isLoading = true;
      let inicio = "";
      let fim = "";
      self.dataFiltro.inicio ? inicio = padronizaDataUS(self.dataFiltro.inicio) : inicio = 0;
      self.dataFiltro.fim ? fim = padronizaDataUS(self.dataFiltro.fim) : fim = 0;
      ajax("get", "/assinaturas/active/"+inicio+"/"+fim)
        .then((response) => {
          self.isLoading = false;
          self.assinaturas = response;
          self.assinaturas.map((assinatura)=> {
            assinatura.status = self.padronizaStatusAssinante(assinatura.status);
          })
        })
        .catch((error) => {
          self.isLoading = false;
          tratamento_requisicao(error, this);
        });
    } else {
      self.$router.replace(self.$route.query.redirect || "/");
    }
  },
};
</script>
<style>
    .button-content {
      display: flex;
      flex-direction: row;
      flex-wrap: nowrap;
      justify-content: space-around;
      width: 8em;
    }
</style>